import type { SettlementAttachment as GQLItem } from '../../../generated/api.graphql';

export type SettlementAttachment = {
  id: number;
  identifier: string;
  url: string;
};

/**
 * Every field is nullable on the schema and required here, so a row missing one is dropped rather
 * than carried half-built -- the filter the legacy payment mapper has always applied.
 */
export const fromGql = (item: GQLItem): SettlementAttachment | undefined => {
  if (item.id == null || item.identifier == null || item.url == null) {
    return undefined;
  }

  return { id: item.id, identifier: item.identifier, url: item.url };
};

export const fromGqlCollection = (items?: GQLItem[] | null): SettlementAttachment[] =>
  (items ?? []).map(fromGql).filter((item): item is SettlementAttachment => item !== undefined);
